/**
 * lista de colecciones de BD
 */
export enum COLLECTIONS_BD {
  advertisements = 'advertisements',
  restaurants = 'restaurants',
  employees = 'employees',
  admins = 'admins',
  categories_supplies = 'categories-supplies',
  companies = 'companies',
  incomes = 'incomes',
  egress = 'egress',
  products = 'products',
  units = 'units',
  clients = 'clients',
  delivery = 'delivery',
  config_delivery = 'config-delivery',
  config_room_service = 'config-room-service',
  reserve = 'reserve',
  customers = 'customers',
  room_service = 'room-service'
}
